import '@/styles/livePlay.scss';
import React, { useState, useEffect, Fragment, useRef } from 'react';
import Player from 'aliplayer-react';
import { Icon, Toast, Tabs, NavBar, Tag } from 'antd-mobile';
import {
  getBooleanValue,
  getParamBiz,
  getDefaultCover,
  checkPermition,
  initWs,
} from '../../../utils';
import { info as lessondetail, getPlayUrl } from '../../../services/saas/active';
import { detail as conferencedetail } from '../../../services/saas/conference';
import { info as liveChanneldetail } from '../../../services/saas/liveChannel';
import { info as judges } from '@/services/saas/ratingJudge';
import { getConnections } from '@/services/saas/fileInfo';
import { addWatchRecord, addVisitorRecord } from '@/services/saas/watchRecord';
import { getUser, checkLogin } from '../../../utils';
import Chat from '@/components/chat';
import Openfire from '@/components/openfire';
import Judge from '@/components/judge';

function LivePlay(props) {
  const { chat_tool, watch_record_heartbeat_interval } = getParamBiz();
  const [tabList, setTabList] = useState([
    { title: '课程详情', key: 'detail' },
    { title: '互动交流', key: 'chat' },
  ]);
  const [selected, setSelected] = useState('detail');
  const [ins, setIns] = useState();
  const [config, setConfig] = useState({
    type: '',
    source: '',
    pic: '',
    width: '100%',
    height: '100%',
    autoplay: false,
    isLive: true,
    rePlay: false,
    playsinline: true,
    preload: true,
    controlBarVisibility: 'hover',
    useH5Prism: true,
  });

  const [liveInfo, setInfo] = useState({
    title: '',
    teacher: '',
    avatar: '',
    deptName: '',
    attr: '',
    desc: '',
  });

  const [errorInfo, setErrorInfo] = useState({
    error: false,
    errorText: '',
  });

  const {
    match: {
      params: { playType, id },
    },
  } = props;

  const { teacher: teacherCover } = getDefaultCover();

  const storeRef = useRef({});
  const { userId } = getUser() || {};

  const getLiveInfo = async function () {
    if (playType === 'lesson') {
      const response = await lessondetail({ id });
      if (response.success && response.data) {
        const { streamId, lessonName, description, creatorInfo, liveStatus } = response.data;
        const { avatar, realName: teacher, deptName } = creatorInfo || {};
        setInfo({
          title: lessonName,
          teacher,
          avatar,
          deptName,
          attr: '',
          desc: description,
        });
        if (String(liveStatus) === '0') {
          Toast.info('直播未开始，请稍后再来~');
          setErrorInfo({
            error: true,
            errorText: '直播未开始，请稍后再来~',
          });
        } else if (String(liveStatus) === '2') {
          Toast.info('直播已结束');
          setErrorInfo({
            error: true,
            errorText: '直播已结束',
          });
        } else {
          if (streamId) {
            getCheckOnline(streamId);
          } else {
            Toast.info('未到上课时间，请稍后再来~');
            setErrorInfo({
              error: true,
              errorText: '未到上课时间，请稍后再来~',
            });
          }
        }
      }
    }
    if (playType === 'conference') {
      const response = await conferencedetail({ id });
      if (response.success && response.data) {
        const {
          liveRecordInfo,
          name,
          teachInfo,
          deptName,
          conferenceAttributeDetailList,
          description,
          sceneCode,
          conferenceStatus,
        } = response.data;
        setInfo({
          title: name,
          teacher: teachInfo.lecturerName,
          avatar: teachInfo.lecturerAvatar,
          deptName: deptName,
          attr: conferenceAttributeDetailList,
          desc: description,
        });
        if (String(conferenceStatus) === '0') {
          Toast.info('直播未开始，请稍后再来~');
          setErrorInfo({
            error: true,
            errorText: '直播未开始，请稍后再来~',
          });
        } else if (String(conferenceStatus) === '2') {
          Toast.info('直播已结束');
          setErrorInfo({
            error: true,
            errorText: '直播已结束',
          });
        } else {
          if (liveRecordInfo.fileinfoId) {
            getCheckOnline(liveRecordInfo.fileinfoId);
          } else {
            Toast.info('直播未开始，请稍后再来~');
            setErrorInfo({
              error: true,
              errorText: '直播未开始，请稍后再来~',
            });
          }
          if (sceneCode === '4') {
            checkLogin({
              onLogin: () => {
                checkjudges(id);
              },
            });
          }
        }
      }
    }
    if (playType === 'liveChannel') {
      const response = await liveChanneldetail({ id });
      if (response.success && response.data) {
        const {
          fileInfoId,
          activityName,
          lecturer,
          lectureDept,
          description,
          liveChannelAttributeList,
        } = response.data;
        setInfo({
          title: activityName,
          teacher: lecturer,
          avatar: '',
          deptName: lectureDept,
          attr: liveChannelAttributeList,
          desc: description,
        });
        if (fileInfoId) {
          getCheckOnline(fileInfoId);
        } else {
          Toast.info('未到上课时间，请稍后再来');
          setErrorInfo({
            error: true,
            errorText: '未到上课时间，请稍后再来',
          });
        }
      }
    }
  };

  const checkjudges = async (conferenceId) => {
    const resp = await judges({ bizId: conferenceId, bizType: 'conference' });
    if (resp && resp.success) {
      const judge = resp.data;
      if (judge) {
        const { userId } = getUser() || {};
        if (judge.filter((item) => item.judgeId === userId).length > 0) {
          setTabList((e) => [...e, { title: '评委评分', key: 'judgement' }]);
        }
      }
    }
  };

  const getCheckOnline = async function (id) {
    const playUrl = {},
      originalUrl = {};
    let websocketUrl = '';
    if (playType === 'conference' || playType === 'liveChannel') {
      const respConnect = await getConnections({ fileInfoId: id });
      if (respConnect.success && respConnect.data.length > 0) {
        const validStream = respConnect.data
          .filter((item) => item.pushClients > 0)
          .map((item) => item.streamFlag);
        if (validStream.length > 0) {
          const respUrl = await getPlayUrl({
            fileInfoId: id,
            playProtocol: 'hls',
          });
          if (respUrl.success) {
            respUrl.data.hls
              .filter((item) => validStream.includes(item.streamFlag))
              .forEach((item) => {
                playUrl[item.streamFlag] = item.url;
                originalUrl[item.streamFlag] = item.originalUrl;
              });
            if (respUrl.data.hls[0] && respUrl.data.hls[0].websocketUrl) {
              websocketUrl = respUrl.data.hls[0].websocketUrl;
            }
            wsConnect(originalUrl, playUrl, websocketUrl, config);
          }
        } else {
          setErrorInfo({
            error: true,
            errorText: '暂无信号，请稍后再试',
          });
          Toast.info('暂无信号，请稍后再试');
        }
      }
    }
    if (playType === 'lesson') {
      const respConnect = await getConnections({ streamId: id });
      if (respConnect.success && respConnect.data.length > 0) {
        const validStream = respConnect.data
          .filter((item) => item.pushClients > 0)
          .map((item) => item.streamFlag);
        if (validStream.length > 0) {
          const respUrl = await getPlayUrl({
            streamId: id,
            playProtocol: 'hls',
          });
          if (respUrl.success) {
            const playUrl = {};
            respUrl.data.hls
              .filter((item) => validStream.includes(item.streamFlag))
              .forEach((item) => {
                playUrl[item.streamFlag] = item.url;
                originalUrl[item.streamFlag] = item.originalUrl;
              });
            if (respUrl.data.hls[0] && respUrl.data.hls[0].websocketUrl) {
              websocketUrl = respUrl.data.hls[0].websocketUrl;
            }
            config.source = JSON.stringify(playUrl);
            setConfig({ ...config });
            wsConnect(originalUrl, playUrl, websocketUrl, config);
          }
        } else {
          setErrorInfo({
            error: true,
            errorText: '暂无信号，请稍后再试',
          });
          Toast.info('暂无信号，请稍后再试');
        }
      }
    }
  };

  const wsConnect = (originalUrl, playUrl, websocketUrl, config) => {
    if (JSON.stringify(playUrl) !== '{}') {
      storeRef.current.originalUrl = originalUrl;
      config.source = JSON.stringify(playUrl);
      storeRef.current.wsIns = initWs(websocketUrl, (isConnect) => {
        storeRef.current.isConnect = isConnect;
        setConfig({ ...config });
      });
    }
  };

  const sendStop = () => {
    if (storeRef.current.wsIns && storeRef.current.isConnect) {
      storeRef.current.wsIns.send(
        JSON.stringify({
          jsonrpc: '2.0',
          method: 'onStop',
          params: {
            url: storeRef.current.originalUrl[storeRef.current.quality],
          },
        }),
      );
    }
  };

  const sendStart = () => {
    if (storeRef.current.wsIns && storeRef.current.isConnect) {
      storeRef.current.wsIns.send(
        JSON.stringify({
          jsonrpc: '2.0',
          method: 'onPlay',
          params: {
            url: storeRef.current.originalUrl[storeRef.current.quality],
          },
        }),
      );
    }
  };

  const addRecord = async () => {
    if (userId) {
      const param = {
        bizId: id,
        bizType: playType,
        terminalType: 'h5',
        userId,
        addWatchTimesFlag: playType === 'conference',
      };
      if (storeRef.current.watchId) {
        param.watchId = storeRef.current.watchId;
      }
      const responsive = await addWatchRecord(param);
      if (responsive.success && responsive.data) {
        storeRef.current.watchId = responsive.data;
      }
    }
  };

  useEffect(() => {
    if (ins) {
      const play = () => {
        ins.play();
      };
      ins.on('canplay', play);
      return () => {
        ins.off('canplay', play);
      };
    }
  });

  useEffect(() => {
    checkPermition(id, playType, null, () => {
      getLiveInfo();
    });
    if (!userId) {
      addVisitorRecord({ bizType: playType, bizId: id, playType: 'live' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={`livePlay${getBooleanValue('IS_IMMERSE', false) ? ' immerse' : ''}`}>
      <NavBar
        mode="light"
        icon={<Icon type="left" style={{ color: '#fff' }} />}
        onLeftClick={() => window.history.go(-1)}
      >
        <span>{liveInfo.title}</span>
      </NavBar>
      <div className="player">
        {errorInfo.error ? (
          <div className="errorText">{errorInfo.errorText}</div>
        ) : (
          config.source && (
            <Player
              config={{
                ...config,
                components: [
                  {
                    name: 'QualityComponent',
                    type: Player.components.QualityComponent,
                    args: [
                      (value) => {
                        storeRef.current.quality = value;
                      },
                    ],
                  },
                ],
              }}
              onGetInstance={(instance) => {
                setIns(instance);
                instance.on('sourceloaded', (params) => {
                  const paramData = params.paramData;
                  const desc = paramData.desc;
                  const definition = paramData.definition;
                  instance.getComponent('QualityComponent').setCurrentQuality(desc, definition);
                  storeRef.current.quality = desc;
                });
                instance.on('play', () => {
                  sendStart();
                  addRecord();
                  if (playType === 'conference' && !storeRef.current.addRecordInterval) {
                    storeRef.current.addRecordInterval = setInterval(
                      () => {
                        addRecord();
                      },
                      watch_record_heartbeat_interval
                        ? window.parseInt(watch_record_heartbeat_interval) * 1000
                        : 60 * 1000,
                    );
                  }
                });
                instance.on('pause', () => {
                  sendStop();
                });
                instance.on('end', () => {
                  sendStop();
                });
                instance.on('error', ({ paramData }) => {
                  sendStop();
                });
              }}
            />
          )
        )}
      </div>
      <div className="livePlay-info">
        <Tabs
          tabs={tabList}
          tabBarPosition="top"
          page={selected}
          initialPage={selected}
          tabBarUnderlineStyle={{
            width: `11.867vw`,
            height: '0.667vw',
            backgroundColor: '#4590fc',
            borderRadius: '0.332vw',
            marginLeft: tabList.length === 3 ? '11vw' : '19vw',
          }}
          animated={false}
          swipeable={false}
          useOnPan={false}
          prerenderingSiblingsNumber={0}
          onChange={async (tab) => {
            setSelected(tab.key);
          }}
        >
          <Fragment key="detail">
            <div className="detail">
              <div className="post">
                <img src={liveInfo.avatar ? liveInfo.avatar : teacherCover} alt="" />
              </div>
              <div>
                <div className="teacher">{liveInfo.teacher}</div>
                <div className="dept">{liveInfo.deptName}</div>
                <div className="tags">
                  {liveInfo.attr
                    ? liveInfo.attr.map((item, index) => (
                        <Tag small key={item.attributeId} style={{ margin: '3px' }} color="blue">
                          {item.attributeValueName}
                        </Tag>
                      ))
                    : null}
                </div>
              </div>
              <div className="desc">课程简介：</div>
              <div className="intro">{liveInfo.desc}</div>
            </div>
          </Fragment>
          <Fragment key="chat">
            <div style={{ height: '100%' }}>
              {chat_tool === 'tencent' ? (
                <Chat groupId={id} groupName={`${liveInfo.title}所在群组`} />
              ) : (
                <Openfire groupId={id} />
              )}
            </div>
          </Fragment>
          <Fragment key="judgement">
            <Judge id={id} />
          </Fragment>
        </Tabs>
      </div>
    </div>
  );
}

export default LivePlay;
